import { Controls } from '../../controls';

class _HammerService {
  private static _instance: _HammerService;
  private hammerjsStore: any | undefined = undefined;
  private dynamicImportHammerjs = async () => {
    //@ts-ignore
    return await import('hammerjs');
  };
  private storeHammerjs = async () => {
    this.hammerjsStore = await (await this.dynamicImportHammerjs()).default;
  };

  public Hammer:
    | {
        get: (selector: 'pinch' | 'pan') => { set: (args: object) => void };
        on: (
          selector:
            | 'double tap'
            | 'pan'
            | 'pinch'
            | 'pinchstart'
            | 'pinchend'
            | 'panstart'
            | 'panEnd',
          callback: (e: any) => void
        ) => void;
      }
    | undefined;

  private constructor() {
    if (Controls.IsWindowDefined()) {
      this.storeHammerjs();
    }
  }

  public static Instance() {
    return this._instance || (this._instance = new this());
  }

  public init = () => {
    //init ensured;
  };

  public setHammerjs = () => {
    if (Controls.IsWindowDefined()) {
      (window as any).Hammer = this.hammerjsStore;
      this.Hammer = this.hammerjsStore;
    }
  };
}

export const HammerService = _HammerService.Instance();
